/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_Totp_Sha1_Warning_TooltipInputs */



/**
* | output |
* | --- |
* | "This device uses SHA-1, which is less secure than SHA-256. Re-enroll with SHA-256 if your authenticator supports it." |
*
* @param {Profile_Security_Totp_Sha1_Warning_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_totp_sha1_warning_tooltip = /** @type {((inputs?: Profile_Security_Totp_Sha1_Warning_TooltipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Totp_Sha1_Warning_TooltipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Gerät verwendet SHA-1, das weniger sicher als SHA-256 ist. Registriere es erneut mit SHA-256, wenn dein Authenticator das unterstützt.")
	return /** @type {LocalizedString} */ ("This device uses SHA-1, which is less secure than SHA-256. Re-enroll with SHA-256 if your authenticator supports it.")
});